exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order_item__name br[data-v-111ab2e5]{display:none}.bill_loader img[data-v-111ab2e5]{max-width:30px}.bill_loader[data-v-111ab2e5]{text-align:center}@media screen and (max-width:800px){.bill_scroll[data-v-111ab2e5]{display:none}}", ""]);

// exports
